import * as React from 'react';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';

interface IUnsupportedWidgetProps extends IWidgetComponentProps
{
    reason?:string;
}

export class UnsupportedWidget extends React.Component<IUnsupportedWidgetProps, any>
{
    render()
    {
        const {prop, reason} = this.props;
        const {definition} = prop;

        return (
            <div>
                <span>Unsupported field {definition.label}</span>
                {reason && <em>: {reason}</em>}
            </div>
        );
    }
}
